/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

// Formik
import { useFormik } from 'formik';

// Validation
import { bdosRegisterSchema } from 'yupSchemas';

// Material
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

// Google
import ReCAPTCHA from 'react-google-recaptcha';

// Components
import { Button } from 'components';
import { MaskedInputCNPJ } from 'components/MaskedInputs';

// Helpers
import { cleanCNPJ } from 'helpers/cnpj';

// Actions
import * as OperatorsActions from 'store/ducks/operators/actions';
import { setOpen } from 'store/ducks/dialogs/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import environments from 'constants/enviroments';
import AUTH from 'constants/auth';

// Modal Success
import { ModalSuccess } from './components';

// Styles
import useStyles from './formBdosRegister.styles';

const FormBdosRegister: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const useOperators = () =>
    useSelector((state: ApplicationState) => state.operators);
  const operators = useOperators();

  if (operators?.operatorCreated.id) {
    dispatch(
      setOpen({
        open: true,
        content: <ModalSuccess />,
      }),
    );
  }

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      companyName: '',
      cnpj: '',
      recaptcha: null,
    },
    validationSchema: bdosRegisterSchema,
    onSubmit: (values) => {
      const cnpj = cleanCNPJ(values.cnpj);

      const newModules: string[] = [];
      Object.values(AUTH.MODULES).forEach((module) => {
        if (module.type === 'SUPERVISOR') {
          newModules.push(module.value);
          if (module.includes && module.includes.length) {
            module.includes.forEach((item) => newModules.push(item));
          }
        }
      });

      dispatch(
        OperatorsActions.createOperatorRequest({
          name: values.companyName,
          cnpj,
          recaptcha: values.recaptcha,
          supervisors: [
            {
              name: values.name,
              email: values.email,
              modules: newModules,
            },
          ],
        }),
      );
    },
  });

  return (
    <>
      <Typography variant='h4'>Preencha os campos abaixo</Typography>
      <form onSubmit={formik.handleSubmit} name='Form Bdos Register'>
        <Grid container direction='row' spacing={1}>
          <Typography variant='h6'>Seus dados</Typography>
          <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
            <TextField
              error={Boolean(formik.errors.name && formik.touched.name)}
              fullWidth
              helperText={
                formik.errors.name && formik.touched.name && formik.errors.name
              }
              id='text-field-name'
              label='Nome Completo'
              margin='normal'
              name='name'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.name}
              variant='outlined'
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
            <TextField
              error={Boolean(formik.errors.email && formik.touched.email)}
              fullWidth
              helperText={
                formik.errors.email &&
                formik.touched.email &&
                formik.errors.email
              }
              id='text-field-email'
              label='E-mail'
              margin='normal'
              name='email'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.email}
              variant='outlined'
            />
          </Grid>
          <Typography variant='h6'>Dados da empresa</Typography>
          <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
            <TextField
              error={Boolean(
                formik.errors.companyName && formik.touched.companyName,
              )}
              fullWidth
              helperText={
                formik.errors.companyName &&
                formik.touched.companyName &&
                formik.errors.companyName
              }
              id='text-field-companyName'
              label='Nome da Empresa'
              margin='normal'
              name='companyName'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.companyName}
              variant='outlined'
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
            <TextField
              InputProps={{ inputComponent: MaskedInputCNPJ as any }}
              error={Boolean(formik.errors.cnpj && formik.touched.cnpj)}
              fullWidth
              helperText={
                formik.errors.cnpj && formik.touched.cnpj && formik.errors.cnpj
              }
              id='text-field-cnpj'
              label='CNPJ'
              margin='normal'
              name='cnpj'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.cnpj}
              variant='outlined'
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
            <ReCAPTCHA
              onChange={(value) => formik.setFieldValue('recaptcha', value)}
              sitekey={`${environments.GOOGLE.RECAPTCHA_SITE_KEY}`}
            />
          </Grid>
        </Grid>

        <Grid
          className={classes.rowButton}
          container
          direction='row'
          spacing={2}>
          <Grid item lg={6} md={6} sm={12} xl={6} xs={12}>
            <Button
              color='primary'
              showLoading={operators?.loading}
              style={{ width: 200 }}
              type='submit'
              variant='contained'>
              Criar
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default FormBdosRegister;
export { FormBdosRegister };
